export default __webpack_public_path__ + "static/media/latest-news-img1.b62f4724.jpg";